import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
  clientname,
  currentTenant,
  dataaccess,
  financialyearend,
  financialyearstart,
  logo,
  thousandsdisplay,
  userid,
  currency,
  theme,
} from "../../Common/Credentials";
import SalesServices from "../SalesServices";
import { spin } from "../../Common/NewLoader";
import { salesid } from "../../Common/Permissions";
import CustomToolbar from "../../CommonComponents/CustomToolbar";
import {
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  MenuItem,
} from "@mui/material";
import IOSSwitch from "../../CommonComponents/IOSSwitch";
import { NumericFormat } from "react-number-format";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import UsercustomerService from "../../Masters/Usercustomers/UsercustomerService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import UpArrow from "../../images/Icons/up-arrow.png";
import EditIcon from "../../images/Icons/edit.png";
import ViewIcon from "../../images/Icons/preview.png";

// Import CSS
import '../../NewUI/NewUI.css';
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TabSwitch from "../../NewUI/NewComponents/TabSwitch.jsx";

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class SalesOrderContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saleOrder: [],
      loading: false,
      salestype: false,
      service: [],
      completedso: [],
      cancelledso: [],
      so: true,
      comp: false,
      canl: false,
      activeTab: "so",
      pendingsoitems: [],
      completedsoitems: [],
      pendingbyitem: true,
      compbyitem: false,
      usercustomers: [],
      type: "Sales By Order",
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      searchTerm: "",
      showSearch: false,
      isMobile: window.innerWidth <= 768,
      currentView: 'list',
      selectedOrder: null,
      hoveredRow: null,
      filteredData: [],
      filteredSidebarData: [],
      currentPage: 1,
      itemsPerPage: 20,
      hasScrolledToSelected: false,
      sortConfig: { key: 'createdAt', direction: 'desc' },
      hovered: null,
      isActionHovered: null,
    };
    this.handleResize = this.handleResize.bind(this);
    this.refreshSalesorder = this.refreshSalesorder.bind(this);
    this.refreshcompletdorcancelledSO = this.refreshcompletdorcancelledSO.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.updateFilteredData = this.updateFilteredData.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.formatCurrencyAsString = this.formatCurrencyAsString.bind(this);
    this.getCurrentPageData = this.getCurrentPageData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.handleOrderClick = this.handleOrderClick.bind(this);
    this.handleBackToList = this.handleBackToList.bind(this);
    this.sortData = this.sortData.bind(this);
    this.getSortedData = this.getSortedData.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.sidebarRef = React.createRef();
    this.scrollTimeout = null;
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrencyAsString(value) {
    if (value === null || value === undefined) return '0';
    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  }

  formatCurrency(value, searchTerm = null) {
    if (value === null || value === undefined) return '0';

    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    const formattedNumber = Number(numericValue).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const fullFormattedString = `${prefix}${formattedNumber}`;

    if (searchTerm) {
      return this.highlightSearchText(fullFormattedString, searchTerm);
    }

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  formatCurrencyWithConversion(amount, ccamount, invCurrency, convRate, mainCurrency, color, searchTerm) {
    const numAmount = Number(amount || 0);
    const conversionRate = Number(convRate || 1);

    const mainPrefix = mainCurrency === 'INR' ? '₹ ' : mainCurrency === 'USD' ? '$ ' : mainCurrency + ' ';
    const formattedMain = `${mainPrefix}${numAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    const convertedAmount = ccamount ? ccamount : numAmount * conversionRate;
    const invPrefix = invCurrency === 'INR' ? '₹ ' : invCurrency === 'USD' ? '$ ' : invCurrency + ' ';
    const formattedConverted = `${invPrefix}${convertedAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    if (mainCurrency !== invCurrency && numAmount > 0) {
      return (
        <div style={{ textAlign: 'right', color }}>
          <div>{this.highlightSearchText(formattedMain, searchTerm)}</div>
          <div style={{ fontSize: '0.72rem', color: '#888' }}>
            {this.highlightSearchText(formattedConverted, searchTerm)}
          </div>
        </div>
      );
    }

    return (
      <span style={{ color }}>
        {this.highlightSearchText(formattedMain, searchTerm)}
      </span>
    );
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  handleTabChange = (value) => {
    this.setState({ activeTab: value }, () => {
      if (value === "completed") {
        this.handlecompChange();
      } else if (value === "cancelled") {
        this.handlecanlChange();
      } else {
        this.handlesoChange();
      }
    });
  };

  handlesoChange = () => {
    this.setState({ so: true, comp: false, canl: false, currentView: 'list', selectedOrder: null }, () => {
      this.updateFilteredData();
    });
  };
  handlecompChange = () => {
    this.setState({ comp: true, so: false, canl: false, currentView: 'list', selectedOrder: null }, () => {
      this.updateFilteredData();
    });
  };
  handlecanlChange = () => {
    this.setState({ canl: true, so: false, comp: false, currentView: 'list', selectedOrder: null }, () => {
      this.updateFilteredData();
    });
  };
  handlePendingChangeByitem = () => {
    this.setState({ pendingbyitem: true, compbyitem: false, currentView: 'list', selectedOrder: null }, () => {
      this.updateFilteredData();
    });
  };
  handlecompChangeByitem = () => {
    this.setState({ pendingbyitem: false, compbyitem: true, currentView: 'list', selectedOrder: null }, () => {
      this.updateFilteredData();
    });
  };

  refreshSalesorder() {
    let datadao = {
      tenantid: currentTenant,
      startdate: moment().subtract(7, "days"),
      enddate: new Date(),
      userid: userid,
      dataaccess: dataaccess,
    };

    SalesServices.GetSaleOrder(datadao)
      .then((response) => {
        this.setState({
          saleOrder: response.data
            .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
            .filter((e) =>
              this.state.usercustomers.length === 0
                ? e
                : this.state.usercustomers.includes(e.customer)
            )
            .map((e) =>
              Object.assign(e, {
                month: moment(e.createdAt).format("MMMM YYYY"),
              })
            ),
        }, () => {
          this.updateFilteredData();
        });
        this.setState({ loading: false });
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

    SalesServices.getSalesbyItem(datadao).then((res) => {
      this.setState({
        pendingsoitems: res.data
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          .filter((e) =>
            this.state.usercustomers.length === 0
              ? e.delivered + e.preclose + e.returned !== e.quantity
              : this.state.usercustomers.includes(e.customer) &&
              e.delivered + e.preclose + e.returned !== e.quantity
          ),
        completedsoitems: res.data
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          .filter(
            (e) =>
              (this.state.usercustomers.length === 0
                ? e.delivered + e.preclose + e.returned === e.quantity
                : this.state.usercustomers.includes(e.customer)) &&
              e.delivered + e.preclose + e.returned === e.quantity
          ),
      }, () => {
        this.updateFilteredData();
      });
    });
  }

  refreshcompletdorcancelledSO(from, to) {
    let datadao = {
      tenantid: currentTenant,
      startdate: from,
      enddate: to,
      userid: userid,
      dataaccess: dataaccess,
    };
    SalesServices.GetCompletedSo(datadao).then((response) => {
      this.setState({
        completedso: response.data
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          .filter((e) =>
            this.state.usercustomers.length === 0
              ? e
              : this.state.usercustomers.includes(e.customer)
          )
          .map((e) =>
            Object.assign(e, { month: moment(e.createdAt).format("MMMM YYYY") })
          ),
      }, () => {
        this.updateFilteredData();
      });
    });

    SalesServices.GetCancelledSo(datadao).then((response) => {
      this.setState({
        cancelledso: response.data
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          .filter((e) =>
            this.state.usercustomers.length === 0
              ? e
              : this.state.usercustomers.includes(e.customer)
          ),
      }, () => {
        this.updateFilteredData();
      });
    });
  }

  handleFromDateChange = (date) => {
    this.setState({
      fromdate: date,
      todate:
        moment(date).diff(this.state.todate, "days") >= 0
          ? this.state.todate
          : date,
    });
  };

  handleToDateChange = (date) => {
    this.setState({ todate: date });
  };

  handlecompletedDateChange = () => {
    this.refreshcompletdorcancelledSO(this.state.fromdate, this.state.todate);
  };

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });

    UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
      this.setState({
        usercustomers:
          res.data === "" || res.data === undefined
            ? []
            : res.data.customers.split(","),
      }, () => {
        this.refreshSalesorder();
        this.refreshcompletdorcancelledSO(
          moment().subtract(7, "days"),
          new Date()
        );
      })
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentView === 'detail' &&
      this.state.selectedOrder &&
      this.sidebarRef.current &&
      !this.state.hasScrolledToSelected) {

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        const selectedElement = this.sidebarRef.current.querySelector(`[data-order-id="${this.state.selectedOrder.id}"]`);
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.setState({ hasScrolledToSelected: true });
        }
      }, 100);
    }

    if (prevState.currentView !== this.state.currentView && this.state.currentView === 'list') {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.selectedOrder?.id !== this.state.selectedOrder?.id) {
      this.setState({ hasScrolledToSelected: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  getCurrentData() {
    const { type, so, comp, canl, pendingbyitem, compbyitem } = this.state;

    if (type === "Sales By Order") {
      if (so) return this.state.saleOrder;
      if (comp) return this.state.completedso;
      if (canl) return this.state.cancelledso;
      return this.state.saleOrder;
    } else {
      if (pendingbyitem) return this.state.pendingsoitems;
      if (compbyitem) return this.state.completedsoitems;
      return this.state.pendingsoitems;
    }
  }

  updateFilteredData() {
    const { searchTerm, type, so, comp, canl, pendingbyitem, compbyitem } = this.state;

    let data = this.getCurrentData();

    if (!searchTerm.trim()) {
      this.setState({
        filteredData: data,
        filteredSidebarData: this.state.currentView === 'detail' ? data : data,
        currentPage: 1,
      });
      return;
    }

    const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

    const filtered = data.filter((item) => {
      const checkFields = [
        item.customer,
        item.customsoid,
        item.agent,
        item.sotype,
        item.status,
        item.createdbyname,
        item.grandtotal?.toString(),
        item.month,
      ];

      return checkFields.some((field) => {
        if (field === undefined || field === null) return false;

        const raw = String(field);
        const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

        return (
          cleanField.includes(cleanSearch) ||
          raw.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    });

    this.setState({
      filteredData: filtered,
      filteredSidebarData: this.state.currentView === 'detail' ? filtered : data,
      currentPage: 1,
    });
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'customer':
          aValue = a.customer || '';
          bValue = b.customer || '';
          break;
        case 'customsoid':
          aValue = a.customsoid || '';
          bValue = b.customsoid || '';
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        case 'grandtotal':
          aValue = Number(a.grandtotal) || 0;
          bValue = Number(b.grandtotal) || 0;
          break;
        case 'status':
          aValue = a.status || '';
          bValue = b.status || '';
          break;
        case 'agent':
          aValue = a.agent || '';
          bValue = b.agent || '';
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  getCurrentPageData() {
    const { filteredData, currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(filteredData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  handleOrderClick(order) {
    this.setState({
      selectedOrder: order,
      currentView: 'detail',
      hasScrolledToSelected: false
    }, () => {
      this.setState({
        filteredSidebarData: this.state.filteredData
      });
    });
  }

  handleBackToList() {
    this.setState({
      currentView: 'list',
      selectedOrder: null,
      hasScrolledToSelected: false
    }, () => {
      this.updateFilteredData();
    });
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();
    const { type, so, comp, canl } = this.state;

    if (this.state.filteredData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No orders found matching your search' : 'No orders available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customer' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customer')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Customer
                    <this.SortIndicator columnKey="customer" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customsoid' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customsoid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    SO ID
                    <this.SortIndicator columnKey="customsoid" />
                  </div>
                </th>
                {type === "Sales By Order" && (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'agent' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('agent')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Agent
                        <this.SortIndicator columnKey="agent" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('createdAt')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Date
                        <this.SortIndicator columnKey="createdAt" />
                      </div>
                    </th>
                  </>
                )}
                {type === "Sales By Item" && (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Item Name
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Quantity
                      </div>
                    </th>
                  </>
                )}
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'grandtotal' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('grandtotal')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Total Amount
                    <this.SortIndicator columnKey="grandtotal" />
                  </div>
                </th>
                {type === "Sales By Order" && so && (
                  <th
                    className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    style={{ textAlign: 'center' }}
                  >
                    <div className="UI-th-content">
                      Aging (Days)
                    </div>
                  </th>
                )}
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'status' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('status')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Status
                    <this.SortIndicator columnKey="status" />
                  </div>
                </th>
                <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((order) => (
                <tr
                  key={order.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === order.id ? 'UI-table-row-hovered' : ''}`}
                  onClick={() => this.handleOrderClick(order)}
                  onMouseEnter={() => this.setState({ hoveredRow: order.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {/* CUSTOMER NAME */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === order.id ? 'UI-item-name-hover' : ''}`}
                  >
                    {(() => {
                      const name = order.customer || "";
                      const lastChar = name.slice(-1);
                      const rest = name.slice(0, -1);

                      return (
                        <>
                          <span>{this.highlightSearchText(rest, this.state.searchTerm)}</span>
                          <Tooltip
                            title="View Details"
                            placement="right"
                            arrow
                            slotProps={{
                              popper: {
                                sx: { pointerEvents: 'none' },
                              },
                            }}
                            open={
                              !this.state.isMobile &&
                              this.state.hoveredRow === order.id &&
                              !this.state.isActionHovered
                            }
                          >
                            <span style={{ display: "inline-block" }}>
                              {this.highlightSearchText(lastChar, this.state.searchTerm)}
                            </span>
                          </Tooltip>
                        </>
                      );
                    })()}
                  </td>

                  {/* SO ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(order.customsoid, this.state.searchTerm)}
                  </td>

                  {/* ADDITIONAL COLUMNS BASED ON TYPE */}
                  {type === "Sales By Order" && (
                    <>
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          order.agent === undefined || order.agent === null || order.agent === "" ? "Direct" : order.agent,
                          this.state.searchTerm
                        )}
                      </td>
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          moment(order.createdAt).format("DD-MM-YYYY HH:mm:ss"),
                          this.state.searchTerm
                        )}
                      </td>
                    </>
                  )}

                  {type === "Sales By Item" && (
                    <>
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(order.itemname, this.state.searchTerm)}
                      </td>
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(order.quantity, this.state.searchTerm)}
                      </td>
                    </>
                  )}

                  {/* TOTAL AMOUNT */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${this.state.hoveredRow === order.id ? 'UI-price-hover' : ''}`}
                    style={{ textAlign: "right" }}
                  >
                    {this.formatCurrency(order.grandtotal, this.state.searchTerm)}
                  </td>

                  {/* AGING FOR ACTIVE SALES BY ORDER */}
                  {type === "Sales By Order" && so && (
                    <td
                      className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      style={{ textAlign: 'center' }}
                    >
                      {(() => {
                        let cre = moment(order.createdAt, "YYYY-MM-DD");
                        let curr = moment(new Date(), "YYYY-MM-DD");
                        return curr.diff(cre, "days");
                      })()} Days
                    </td>
                  )}

                  {/* STATUS */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    <span className={`UI-status-badge UI-status-${order.status?.toLowerCase()}`}>
                      {this.highlightSearchText(order.status, this.state.searchTerm)}
                    </span>
                  </td>

                  {/* ACTION BUTTONS */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    <div className="UI-action-buttons">
                      <Link
                        to={{ pathname: "/saleorderdetails" }}
                        state={{
                          id: order.id,
                          bvstatus: type === "Sales By Order" ? (so ? 0 : (comp ? 1 : 2)) : 0
                        }}
                        className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                        style={{ textDecoration: "none" }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseEnter={() =>
                          this.setState({ isActionHovered: `view-${order.id}` })
                        }
                        onMouseLeave={() => this.setState({ isActionHovered: null })}
                      >
                        <Tooltip title="View Details" arrow slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}>
                          <img
                            src={ViewIcon}
                            alt="View"
                            className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${order.id}` ? 'UI-edit-icon-hover' : ''}`}
                          />
                        </Tooltip>
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {this.renderPagination()}
      </>
    );
  }

  renderTypeTabs() {
    const types = [
      { value: "Sales By Order", label: "Sales By Order" },
      { value: "Sales By Item", label: "Sales By Item" },
    ];

    return (
      // <div
      //   className="UI-tabs-row"
      //   style={{
      //     marginBottom: "16px",
      //     marginTop: "10px",
      //     marginLeft: "10px",
      //   }}
      // >
      //   {types.map((tabType) => (
      //     <TabButton
      //       key={tabType}
      //       active={this.state.type === tabType}
      //       onClick={() =>
      //         this.setState(
      //           {
      //             type: tabType,
      //             so: true,
      //             comp: false,
      //             canl: false,
      //             pendingbyitem: true,
      //             compbyitem: false,
      //             currentView: 'list',
      //             selectedOrder: null,
      //             sortConfig: { key: 'customer', direction: 'asc' }
      //           },
      //           this.updateFilteredData
      //         )
      //       }
      //     >
      //       {tabType}
      //     </TabButton>
      //   ))}
      // </div>
      <div className="tw-m-2">
        <TabSwitch
          value={this.state.type}
          onChange={(value) => {
            this.setState(
              {
                type: value,
                so: true,
                comp: false,
                canl: false,
                pendingbyitem: true,
                compbyitem: false,
                currentView: 'list',
                selectedOrder: null,
                sortConfig: { key: 'customer', direction: 'asc' }
              },
              this.updateFilteredData
            )
          }}
          activeTabClass={theme === "modern" ? "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white tw-py-1" : "!tw-bg-[#4d4d4d] tw-text-white tw-py-1"}
          options={types}
        />
      </div>
    );
  }

  renderStatusTabs() {
    const isMobile = this.state.isMobile;
    const { type, so, comp, canl, pendingbyitem, compbyitem } = this.state;

    if (type === "Sales By Order") {
      const tabs = [
        { key: 'so', label: 'Active Orders', handler: this.handlesoChange, active: so },
        { key: 'comp', label: 'Completed Orders', handler: this.handlecompChange, active: comp },
        { key: 'canl', label: 'Cancelled Orders', handler: this.handlecanlChange, active: canl }
      ];
      const options = [
        { value: "so", label: "Active Orders" },
        { value: "completed", label: "Completed Orders" },
        { value: "cancelled", label: "Cancelled Orders" },
      ];
      return (
        <div className="UI-quotation-tabs-container !tw-bg-white !tw-border-none">
          {/* {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''
                } ${this.state.hovered === `${tab.key}-tab`
                  ? 'UI-quotation-tab-hovered'
                  : ''
                }`}
              onClick={tab.handler}
              onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
            </div>
          ))} */}

          <TabSwitch
            value={this.state.activeTab}
            onChange={this.handleTabChange}
            options={options}
          />

          {/* Date Filters for Completed/Cancelled tabs */}
          {(comp || canl) && (
            <div className="UI-date-filter-container !tw-bg-white !tw-border-none">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <DatePicker
                    label="From Date"
                    value={this.state.fromdate}
                    onChange={this.handleFromDateChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        style={{ width: '140px' }}
                      />
                    )}
                  />
                  <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
                  <DatePicker
                    label="To Date"
                    value={this.state.todate}
                    onChange={this.handleToDateChange}
                    minDate={this.state.fromdate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        style={{ width: '140px' }}
                      />
                    )}
                  />
                </div>
              </LocalizationProvider>
              <button
                className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
                onClick={this.handlecompletedDateChange}
                onMouseEnter={() => this.setState({ hovered: 'apply' })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
                Apply
              </button>
            </div>
          )}
        </div>
      );
    } else {
      // const tabs = [
      //   { key: 'pendingbyitem', label: 'Active/Pending', handler: this.handlePendingChangeByitem, active: pendingbyitem },
      //   { key: 'compbyitem', label: 'Completed', handler: this.handlecompChangeByitem, active: compbyitem }
      // ];
      const options = [
        { value: "pendingbyitem", label: "Active/Pending" },
        { value: "compbyitem", label: "Completed" }
      ];
      return (
        <div className="UI-quotation-tabs-container !tw-bg-white !tw-border-none">
          {/* {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''
                } ${this.state.hovered === `${tab.key}-tab`
                  ? 'UI-quotation-tab-hovered'
                  : ''
                }`}
              onClick={tab.handler}
              onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
            </div>
          ))} */}
          <TabSwitch value={this.state.pendingbyitem ? "pendingbyitem" : "compbyitem"} onChange={(val) => val == "pendingbyitem" ? this.handlePendingChangeByitem() : this.handlecompChangeByitem()} options={options} />
        </div>
      );
    }
  }

  renderPagination() {
    const { filteredData, currentPage, itemsPerPage, isMobile } = this.state;

    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} orders
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderDetailView() {
    const { selectedOrder, filteredSidebarData } = this.state;
    const { type, so, comp, canl } = this.state;
    if (!selectedOrder) return null;

    return (
      <div className="UI-detail-view">
        {/* Sidebar */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${this.state.hovered === 'back' ? 'UI-back-button-hover' : ''}`}
              onClick={this.handleBackToList}
              onMouseEnter={() => this.setState({ hovered: 'back' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>
          <div className="UI-sidebar-list" ref={this.sidebarRef}>
            {filteredSidebarData.map((order) => (
              <div
                key={order.id}
                data-order-id={order.id}
                className={`UI-sidebar-item ${selectedOrder.id === order.id ? 'UI-sidebar-item-active' : ''} ${this.state.hovered === order.id ? 'UI-sidebar-item-hover' : ''}`}
                onClick={() => this.setState({ selectedOrder: order })}
                onMouseEnter={() => this.setState({ hovered: order.id })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <div className={`UI-sidebar-item-name ${this.state.hovered === order.id ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {this.highlightSearchText(order.customer, this.state.searchTerm)}
                </div>
                <div className={`UI-sidebar-item-code ${this.state.hovered === order.id ? 'UI-sidebar-item-code-hover' : ''}`}>
                  {this.highlightSearchText(order.customsoid, this.state.searchTerm)}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">{this.highlightSearchText(selectedOrder.customer, this.state.searchTerm)}</h2>
              <p className="UI-detail-subtitle">
                SO ID: {this.highlightSearchText(selectedOrder.customsoid, this.state.searchTerm)}
              </p>
            </div>
            <div className="UI-detail-actions">
              <Link
                to={{ pathname: "/saleorderdetails" }}
                state={{
                  id: selectedOrder.id,
                  bvstatus: type === "Sales By Order" ? (so ? 0 : (comp ? 1 : 2)) : 0
                }}
                className={`UI-detail-action-button UI-detail-edit-button ${this.state.hovered === "view" ? 'UI-edit-button-hover' : ''}`}
                style={{ textDecoration: "none" }}
                onMouseEnter={() => this.setState({ hovered: "view" })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <Tooltip title="View Full Details" arrow slotProps={{
                  popper: {
                    sx: { pointerEvents: 'none' },
                  },
                }}>
                  <img
                    src={ViewIcon}
                    alt="View"
                    className={`UI-action-icon ${this.state.hovered === "view" ? 'UI-action-icon-hover' : ''}`}
                  />
                </Tooltip>
              </Link>
            </div>
          </div>
          <div className="UI-detail-grid">
            {/* Basic Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Basic Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Customer</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.customer, this.state.searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">SO ID</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.customsoid, this.state.searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Created Date</span>
                <span className="UI-detail-value">
                  {moment(selectedOrder.createdAt).format("DD-MM-YYYY HH:mm:ss")}
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Agent</span>
                <span className="UI-detail-value">
                  {selectedOrder.agent === undefined || selectedOrder.agent === null || selectedOrder.agent === ""
                    ? "Direct"
                    : this.highlightSearchText(selectedOrder.agent, this.state.searchTerm)}
                </span>
              </div>
              {type === "Sales By Item" && (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Item Name</span>
                    <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.itemname, this.state.searchTerm)}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Quantity</span>
                    <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.quantity, this.state.searchTerm)}</span>
                  </div>
                </>
              )}
            </div>
            {/* Order Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Order Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Status</span>
                <span className="UI-detail-value">
                  <span className={`UI-status-badge UI-status-${selectedOrder.status?.toLowerCase()}`}>
                    {this.highlightSearchText(selectedOrder.status, this.state.searchTerm)}
                  </span>
                </span>
              </div>
              {type === "Sales By Order" && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Type</span>
                  <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.sotype, this.state.searchTerm)}</span>
                </div>
              )}
              <div className="UI-detail-row">
                <span className="UI-detail-label">Created By</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.createdbyname, this.state.searchTerm)}</span>
              </div>
              {type === "Sales By Order" && so && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Aging (Days)</span>
                  <span className="UI-detail-value">
                    {(() => {
                      let cre = moment(selectedOrder.createdAt, "YYYY-MM-DD");
                      let curr = moment(new Date(), "YYYY-MM-DD");
                      return curr.diff(cre, "days");
                    })()} Days
                  </span>
                </div>
              )}
              {type === "Sales By Item" && (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">UOM</span>
                    <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.uom, this.state.searchTerm)}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Pending Quantity</span>
                    <span className="UI-detail-value">
                      {selectedOrder.pending || (selectedOrder.quantity - (selectedOrder.delivered || 0) - (selectedOrder.preclose || 0) - (selectedOrder.returned || 0))}
                    </span>
                  </div>
                </>
              )}
            </div>
            {/* Financial Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Financial Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Total Amount</span>
                <span className="UI-detail-value">
                  {this.formatCurrency(selectedOrder.grandtotal, this.state.searchTerm)}
                </span>
              </div>
              {type === "Sales By Item" && (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Price</span>
                    <span className="UI-detail-value">
                      {this.formatCurrency(selectedOrder.price, this.state.searchTerm)}
                    </span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Tax (%)</span>
                    <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.tax, this.state.searchTerm)}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Total with Tax</span>
                    <span className="UI-detail-value">
                      {this.formatCurrency(selectedOrder.totalpricewtax, this.state.searchTerm)}
                    </span>
                  </div>
                </>
              )}
              <div className="UI-detail-row">
                <span className="UI-detail-label">Month</span>
                <span className="UI-detail-value">{this.highlightSearchText(selectedOrder.month || moment(selectedOrder.createdAt).format("MMMM YYYY"), this.state.searchTerm)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderListView() {
    return (
      <>
        {this.renderTable()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div >
        <Header />
        <Menu />
        <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
          <div className="content-wrapper">
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/sales" }, { name: "Sales Orders", path: null }]} />
                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>Sales Orders</h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      {this.state.currentView === 'detail' && this.state.selectedOrder
                        ? `ID: ${this.state.selectedOrder.customsoid}`
                        : 'Manage your sales orders and track status'
                      }
                    </p>
                  </div>
                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Desktop Search */}
                    {!isMobile && (
                      <div
                        className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                        onClick={() => {
                          if (!this.state.showSearch) this.setState({ showSearch: true });
                        }}
                        onMouseEnter={() => this.setState({ hovered: "search" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className={`fa fa-search UI-search-icon ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`} />
                        {!this.state.showSearch && "Search"}
                        {this.state.showSearch && (
                          <input
                            type="text"
                            className="UI-search-input"
                            placeholder="Search orders..."
                            value={this.state.searchTerm}
                            onChange={(e) => this.handleSearch(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                            onBlur={() => {
                              if (this.state.searchTerm.trim() === "") {
                                this.setState({ showSearch: false });
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        className="UI-mobile-search-input"
                        placeholder="Search orders..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                      />
                    )}
                    {/* New Order button */}
                    {(salesid === "2" || salesid === "3") && (
                      <Link
                        to={{ pathname: "/newsalesorder" }}
                        state={{ id: -1, pagename: "New Order", salestype: false, orderfrom: 0, qid: -1 }}
                        className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                        style={{ textDecoration: "none" }}
                        onMouseEnter={() => this.setState({ hovered: "new" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className="fa fa-plus" /> {isMobile ? "New" : "New Order"}
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <>
                  {this.renderTypeTabs()}
                  {this.renderStatusTabs()}
                  <div style={{ marginTop: '8px' }}>
                    {this.state.currentView === 'list'
                      ? this.renderListView()
                      : this.renderDetailView()
                    }
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>

    );
  }
}

export default withRouter(SalesOrderContent);